<template lang="pug">
.rc
  .rc__card(v-if="estado === 'exito'")
    h1.rc__title Contraseña actualizada
    img.rc__icon(src="@/assets/recuperar-clave/check-circle.svg" alt="")
    p.rc__text
      | Tu clave ha sido cambiada exitosamente. Ya puedes acceder nuevamente a Samtek Center.
    .rc__actions
      router-link.rc__btn.rc__btn--primary(:to="{ name: 'Login' }") Volver al inicio

  .rc__card(v-else-if="estado === 'expirado'")
    h1.rc__title El enlace ha expirado o es inválido
    img.rc__alert(src="@/assets/recuperar-clave/alert.svg" alt="")
    p.rc__text
      | Por razones de seguridad, los enlaces de recuperación solo son válidos por un tiempo limitado y para un solo uso.
    .rc__actions
      router-link.rc__btn.rc__btn--primary(:to="{ name: 'Recuperar Clave' }") Solicitar un nuevo enlace

  .rc__card(v-else)
    h1.rc__title Crea tu nueva contraseña
    form.rc__form(novalidate @submit.prevent="onSubmit")
      .rc__field(:class="{ 'rc__field--error': errores.password }")
        label.rc__label(for="rc-password") Nueva contraseña
        .rc__control
          .rc__input-wrap
            input#rc-password.rc__input.rc__input--password(
              v-model="password"
              :type="verPassword ? 'text' : 'password'"
              autocomplete="new-password"
              placeholder="Ingresa tu Contraseña"
              @input="revalidar"
            )
            button.rc__toggle(
              type="button"
              :aria-label="verPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
              @click="verPassword = !verPassword"
            )
              img(v-if="verPassword" src="@/assets/recuperar-clave/eye-outline.svg" alt="")
              img(v-else src="@/assets/recuperar-clave/eye-off-outline.svg" alt="")
          p.rc__error(v-for="error in errores.password" :key="error") {{ error }}

      .rc__field(:class="{ 'rc__field--error': errores.passwordRepeat }")
        label.rc__label(for="rc-password-repeat") Confirma nueva contraseña
        .rc__control
          .rc__input-wrap
            input#rc-password-repeat.rc__input.rc__input--password(
              v-model="passwordRepeat"
              :type="verPasswordRepeat ? 'text' : 'password'"
              autocomplete="new-password"
              placeholder="Ingresa tu Contraseña"
              @input="revalidar"
            )
            button.rc__toggle(
              type="button"
              :aria-label="verPasswordRepeat ? 'Ocultar contraseña' : 'Mostrar contraseña'"
              @click="verPasswordRepeat = !verPasswordRepeat"
            )
              img(v-if="verPasswordRepeat" src="@/assets/recuperar-clave/eye-outline.svg" alt="")
              img(v-else src="@/assets/recuperar-clave/eye-off-outline.svg" alt="")
          p.rc__error(v-for="error in errores.passwordRepeat" :key="error") {{ error }}

      p.rc__text.rc__text--left La contraseña debe tener al menos 8 caracteres.
      .rc__actions
        button.rc__btn.rc__btn--primary(type="submit" :disabled="loading")
          | Guardar contraseña
          b-spinner(v-if="loading" small)
</template>

<script>
import { mapActions } from 'vuex'

const LARGO_MINIMO = 8

export default {
  data() {
    return {
      estado: 'formulario',
      password: '',
      passwordRepeat: '',
      verPassword: false,
      verPasswordRepeat: false,
      loading: false,
      intentoEnviar: false,
      errores: {
        password: null,
        passwordRepeat: null,
      },
    }
  },
  computed: {
    uid() {
      return this.$route.query.uid || ''
    },
    token() {
      return this.$route.query.token || ''
    },
  },
  created() {
    if (!this.uid || !this.token) this.estado = 'expirado'
  },
  methods: {
    ...mapActions('AuthenticationStore', ['confirmarRecuperacionClave']),

    validar() {
      const errores = { password: null, passwordRepeat: null }

      if (!this.password) {
        errores.password = ['Ingresa tu nueva contraseña']
      } else if (this.password.length < LARGO_MINIMO) {
        errores.password = [`La contraseña debe tener al menos ${LARGO_MINIMO} caracteres`]
      }

      if (!this.passwordRepeat) {
        errores.passwordRepeat = ['Confirma tu nueva contraseña']
      } else if (this.passwordRepeat !== this.password) {
        errores.passwordRepeat = ['Las contraseñas ingresadas no coinciden']
      }

      this.errores = errores
      return !errores.password && !errores.passwordRepeat
    },

    revalidar() {
      if (this.intentoEnviar) this.validar()
    },

    async onSubmit() {
      if (this.loading) return
      this.intentoEnviar = true
      if (!this.validar()) return

      this.loading = true
      try {
        await this.confirmarRecuperacionClave({
          uid: this.uid,
          token: this.token,
          password: this.password,
          passwordRepeat: this.passwordRepeat,
        })
        this.estado = 'exito'
      } catch (err) {
        this.manejarError(err)
      } finally {
        this.loading = false
      }
    },

    manejarError(err) {
      const data = err.response?.status === 400 ? err.response.data || {} : null

      if (data && (data.uid || data.token)) {
        this.estado = 'expirado'
        return
      }

      // El back valida la contraseña con AUTH_PASSWORD_VALIDATORS (similitud,
      // comunes, solo números) y devuelve esos errores en new_password1/2.
      const password = data?.new_password1 || null
      const passwordRepeat = data?.new_password2 || data?.non_field_errors || null
      this.errores = {
        password,
        passwordRepeat: passwordRepeat || (password ? null : ['No pudimos actualizar tu contraseña. Intenta nuevamente.']),
      }
    },
  },
}
</script>

<style lang="scss">
@import '@/style/auth-card.scss';
</style>
